import { addElementToConditionAction } from 'editor/src/store/design/slice';
import { ConditionAddress, MediaElement } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import { addConditionElementToSiblingReflowRowOperation } from './reflowGroupOperations';
import updateHiddenElementsOperation from './updateHiddenElementsOperation';

const addElementToConditionOperation =
  (address: ConditionAddress, optionId: string, element: MediaElement) => (dispatch: ThunkDispatch) => {
    dispatch(addElementToConditionAction({ address, optionId, element }));
    // The condition's own spread, not the viewer's: a design-scoped picklist
    // (showOnAllSpreads) is edited from pages that do not store it.
    dispatch(updateHiddenElementsOperation(address.spreadIndex));
    // Keep reflow rows in sync: if a sibling option of this condition is in a
    // reflow row, this newly-linked element joins it too.
    dispatch(addConditionElementToSiblingReflowRowOperation(address.spreadIndex, element.uuid));
  };

export default addElementToConditionOperation;
